<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Staff</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="staff"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12" v-if="method == 'post'">
                <custom-user-search
                  name="user_id"
                  label="Select the staff"
                  item_name="full_name"
                  item_value="id"
                  icon="mdi-account-search"
                />
              </v-col>
              <div v-if="staff">
                <v-col cols="12" class="mb-6" v-if="method == 'put'">
                  Staff Name : {{ staff.user.full_name }}
                </v-col>
              </div>
              <v-col cols="12">
                <custom-input name="department" label="Department" />
                <custom-input name="role" label="Position" />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
// import baseInput from "../../../components/forms/baseInput";
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    staff: {
      default: () => {},
      type: Object,
    },
  },
  //   mixins: [baseInput],
  data() {
    return {
      key: 1,
      users: [],
    };
  },
  created() {
    this.$http.get(`api/v1/users`).then(({ data, total }) => {
      this.count = total;
      this.users = data;
    });
  },
  computed: {
    url() {
      if (this.staff && this.staff.id) {
        return `api/v1/staff/${this.staff.id}`;
      }
      return "api/v1/staff";
    },
  },
};
</script>
